import {InitAppForPageFn} from '@wix/yoshi-flow-editor';
import {createViewerScript} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/createViewerScript';

// This module is being used in Editor App.
// createControllers will be generated by the flow.
export const initAppForPage: InitAppForPageFn = async (initParams, apis, namespaces, platformServices) => {
  return {
    context: await createViewerScript({}).initAppForPage(initParams, apis, namespaces, platformServices),
  };
};
